import _ from 'underscore';

function toSimpleHash(schema) {
  return _.mapObject(schema.properties, ({
    type,
    schema: propertySchema,
  }) => {
    const obj = { type };

    if (propertySchema) {
      obj.type = propertySchema.name;
    }

    return obj;
  });
}

function definePropertiesType(schema, Schemator) {
  _.each(schema.properties, ({ schema: propertySchema }) => {
    if (propertySchema && !Schemator.getDataType(propertySchema.name)) {
      // eslint-disable-next-line
      defineType(propertySchema, Schemator);
    }
  });
}

function defineType(schema, Schemator) {
  Schemator.defineDataType(schema.name, _.noop);
  definePropertiesType(schema, Schemator);
}

export function defineResource({
  schema,
  store,
  schemator,
  name = schema.name,
  entitySet,
  edm,
  edmRootResourceIdentifier,
}) {
  const resource = store.defineResource({
    // do not pass reference to schema into js-data method, as js-data may
    // perform destructive modifications to the schema argument
    name,
    entitySet,
    edm,
    edmRootResourceIdentifier,
    idAttribute: _.findKey(schema.properties, prop => prop.key === true) || 'Id',
  });

  if (!schemator.getSchema(schema.name)) {
    // TODO: actually we are not using js-data-schema, see http://www.js-data.io/docs/upgrading-to-jsdata-20
    schemator.defineSchema(schema.name, toSimpleHash(schema));

    // seed types
    definePropertiesType(schema, schemator);
  }

  // TODO: [zhbliu][#1404348] This is needed by component/js-data-bulk,
  // we need an elegant way to find schema by resource
  return _.extend(resource, { schema });
}
